import API, { baseURL } from 'utils/api';
import { onError } from 'utils/handlers';
import { store } from 'store';
import {
  SET_CLASIFICACIONES_DE_COMERCIO,
  SET_ESTADOS_DEL_NEGOCIO,
  SET_TIPOS_DE_ESTABLECIMIENTO,
  SET_SECTORES_EMPRESARIALES,
  SET_REGIMEN_DE_EMPRESA,
  SET_TIPOS_DE_EMPRESA,
} from 'store/reducers/catalogs';
import { formatReceived } from 'utils/formatValues';
import axios from 'axios';
import { message } from 'antd';

/**
 * GET Empresa para la caja
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
// eslint-disable-next-line import/prefer-default-export
export const getEmpresaCaja = async (params = null) => {
  try {
    const response = await API.get('/empresas/empresa-caja/', { params });
    if (![200, 206].includes(response.status)) {
      message.info('No se encontraron coincidencias');
      return false;
    }
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Tipos de Documentos
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getRegimenFiscales = async (params) => {
  try {
    const response = await API.get('/empresas/regimen-fiscal/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Tipos de Documentos
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getTiposDeDocumentos = async (params) => {
  try {
    const response = await API.get('/empresas/tipos-de-documento-para-tramites/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};
/**
 * GET Catalogo de Actividades Economicas
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const catActividadesEconomicas = async (params) => {
  try {
    const response = await API.get('', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Catalogo de Actividades
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getCatActividades = async (params) => {
  try {
    const response = await API.get('empresas/actividades', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Catalogo de Actividades (SAT)
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getActividadesEconomicas = async (params) => {
  try {
    const response = await API.get('empresas/actividades-economicas/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Catalogo de Actividad (SAT)
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getActividadEconomica = async (id) => {
  try {
    const response = await API.get(`empresas/actividades-economicas/${id}/`);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Catalogo de Actividades
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getCatalogoActividadesEconomicas = async (params) => {
  try {
    const response = await API.get('empresas/actividades', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Catalogo de Actividades
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getClasesDeActividadEmpresarial = async (params) => {
  try {
    const response = await API.get('empresas/clases-de-actividad-empresarial', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};
// /empresas/clases-de-actividad-empresarial

/**
 * GET Clases de Establecimientos
 * @returns {Promise<Array<object>>}
 */
export const getTiposDeEstablecimientos = async () => {
  try {
    const { tiposDeEstablecimiento } = store.getState().catalogs;
    if (!tiposDeEstablecimiento?.length) {
      const response = await API.get('/empresas/tipos-de-establecimientos/');
      store.dispatch({
        type: SET_TIPOS_DE_ESTABLECIMIENTO,
        payload: response.data,
      });
      return response.data;
    }
    return tiposDeEstablecimiento;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Sectores Comerciales
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getSectoresComerciales = async (params = null) => {
  try {
    const response = await API.get('/empresas/sectores-comerciales/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Clases de Sectores Empresariales
 * @returns {Promise<Array<object>>}
 */
export const getSectores = async () => {
  try {
    const { sectoresEmpresariales } = store.getState().catalogs;
    if (!sectoresEmpresariales?.length) {
      const response = await API.get('/empresas/sectores/');
      store.dispatch({
        type: SET_SECTORES_EMPRESARIALES,
        payload: response.data,
      });
      return response.data;
    }
    return sectoresEmpresariales;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Estados del negocio
 * @returns {Promise<Array<object>>}
 */
export const getEstadosDeNegocio = async () => {
  try {
    const { estadosDelNegocio } = store.getState().catalogs;
    if (!estadosDelNegocio?.length) {
      const response = await API.get('/empresas/estados-de-negocio/');
      store.dispatch({
        type: SET_ESTADOS_DEL_NEGOCIO,
        payload: response.data,
      });
      return response.data;
    }
    return estadosDelNegocio;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Tipos de Establecimiento
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getTiposDeEstablecimiento = async (params) => {
  try {
    if (!store.getState().catalogs.tiposDeEstablecimiento?.length) {
      const response = await API.get('/empresas/tipos-de-establecimientos/', { params });
      store.dispatch({
        type: SET_TIPOS_DE_ESTABLECIMIENTO,
        payload: response.data,
      });
      return response.data;
    }
    return store.getState().catalogs.tiposDeEstablecimiento;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Regimen de Empresas
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getRegimenDeEmpresas = async (params) => {
  try {
    if (!store.getState().catalogs.regimenDeEmpresas?.length) {
      const response = await API.get('/empresas/regimen-de-empresas/', { params });
      store.dispatch({
        type: SET_REGIMEN_DE_EMPRESA,
        payload: response.data,
      });
      return response.data;
    }
    return store.getState().catalogs.regimenDeEmpresas;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Estados del Negocios
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getEstadosDelNegocio = async (params) => {
  try {
    if (!store.getState().catalogs.estadosDelNegocio?.length) {
      const response = await API.get('/empresas/estados-de-negocio/', { params });
      store.dispatch({
        type: SET_ESTADOS_DEL_NEGOCIO,
        payload: response.data,
      });
      return response.data;
    }
    return store.getState().catalogs.estadosDelNegocio;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Clasificaciones de Comercio
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getClasificacionesDeComercio = async (params) => {
  try {
    if (!store.getState().catalogs.clasificacionesDeComercio?.length) {
      const response = await API.get('/empresas/clasificaciones-de-comercio/', { params });
      store.dispatch({
        type: SET_CLASIFICACIONES_DE_COMERCIO,
        payload: response.data,
      });
      return response.data;
    }
    return store.getState().catalogs.estadosDelNegocio;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Tipos de Empresas
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getTiposDeEmpresas = async (params) => {
  try {
    if (!store.getState().catalogs.tiposDeEmpresa?.length) {
      const response = await API.get('/empresas/tipos-de-empresas/', { params });
      store.dispatch({
        type: SET_TIPOS_DE_EMPRESA,
        payload: response.data,
      });
      return response.data;
    }
    return store.getState().catalogs.tiposDeEmpresa;
  } catch (err) {
    onError(err);
    return [];
  }
};
/**
 * Retrieve Tipo de Empresa
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getTipoDeEmpresa = async (id) => {
  try {
    const response = await API.get(`/empresas/tipos-de-empresas/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Tipos de Empresas
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getSectoresEmpresariales = async (params) => {
  try {
    if (!store.getState().catalogs.sectoresEmpresariales?.length) {
      const response = await API.get('/empresas/sectores/', { params });
      store.dispatch({
        type: SET_SECTORES_EMPRESARIALES,
        payload: response.data,
      });
      return response.data;
    }
    return store.getState().catalogs.sectoresEmpresariales;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Estatus de Obligaciones Fiscales
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getEstatusDeObigacionesFiscales = async (params) => {
  try {
    const response = await API.get('/empresas/estatus-de-obligaciones-fiscales/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Tipos de Contribuyente
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getTiposDeContribuyente = async (params) => {
  try {
    const response = await API.get('/empresas/tipos-de-contribuyentes-vinculados/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

export const getTiposDeContratosDePolicias = async () => {
  try {
    const response = await API.get('/empresas/tipos-de-contratos-de-policias/');
    return response.data;
  } catch (error) {
    onError(error);
  }
  return [];
};

export const getTiposDeServiciosDePolicias = async () => {
  try {
    const response = await API.get('/empresas/tipos-de-servicios-de-policias/');
    return response.data;
  } catch (error) {
    onError(error);
  }
  return [];
};

/**
 * GET Catalogo Clasificaciones de Comercio
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getClasificacionesDeComercioCatalogo = async (params) => {
  try {
    const response = await API.get('/empresas/clasificaciones-de-comercio/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};
/**
 * GET Tipos de Declaracion
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getTiposDeDeclaracion = async (params) => {
  try {
    const response = await API.get('/empresas/tipos-de-declaraciones-empresariales/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};
/**
 * GET Estatus de Declaraciones Empresariales
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getEstatusDeDeclaracionesEmpresariales = async (params) => {
  try {
    const response = await API.get('/empresas/estatus-de-declaraciones-empresariales/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Catalogo SCIAN
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getScianCatalogo = async (params) => {
  try {
    const response = await API.get('/empresas/clases-empresariales-administrador/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET SCIAN
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getScian = async (id) => {
  try {
    const response = await API.get(`/empresas/clases-empresariales-administrador/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

export const getSubScianCatalogo = async (params) => {
  try {
    const response = await API.get('/empresas/sub-ramas-empresariales/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};
/**
 * GET Estados de Direcciones Verificadas
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getEstadosDeDireccionesVerificadas = async (params) => {
  try {
    const response = await API.get('/empresas/estatus-de-direcciones-verificadas/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Constancias de Contribuyentes
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getConstanciasDeContribuyentes = async (params) => {
  try {
    const response = await axios.get(`${baseURL}/empresas/constancias-contribuyentes-public/`, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Tipos De Identificacion
 * @param {object} params
 * @returns {Promise<Object[]>}
 */
export const getTiposDeIdentificacion = async (params) => {
  try {
    const response = await API.get(`${baseURL}/empresas/tipos-de-identificaciones/`, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Tipos de contribuyentes solicitantes
 * @returns {Promise<Object[]>}
 */
export const getTiposDeContribuyentesSolicitantes = async () => {
  try {
    const response = await API.get('empresas/tipos-de-contribuyentes-solicitantes/');
    return response.data;
  } catch (error) {
    onError(error);
    return [];
  }
};
